// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1TrackingDataSchema } from './v1/trackingDataSchema';

export const createTrackingDataHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token from tracker application (macOS/Windows app)"),
  'TL-Content-Encoding': z.optional(z.enum(["None", "base64"]).describe("Content encoding type. Use \"base64\" for base64-encoded payload")),
  'TL-Device-Id': z.optional(z.coerce.string().describe("Device MAC address identifier")),
  'TL-System-Username': z.optional(z.coerce.string().describe("System username (base64 encoded if TL-Content-Encoding is base64)")),
});

/**
 * @description Tracking data accepted
 */
export const createTrackingData200Schema = z.unknown();

/**
 * @description Unauthorized
 */
export const createTrackingData401Schema = z.unknown();

export const createTrackingDataMutationRequestSchema = z.lazy(() => v1TrackingDataSchema);

export const createTrackingDataMutationResponseSchema = z.lazy(() => createTrackingData200Schema);
